import React from 'react';

export const ArticleContent = ({ content }) => (
  <div data-testid="article-content" className="text-sm sm:text-base leading-relaxed">
    {content.map((block, index) => {
      const testId = `article-content-${block.type}-${index}`;
      switch (block.type) {
        case 'intro':
          return <p key={index} data-testid={testId} className="text-base sm:text-lg text-gray-700 mb-8 font-medium">{block.text}</p>;
        case 'heading':
          return <h2 key={index} data-testid={testId} className="text-base md:text-lg font-semibold text-gray-800 mt-8 mb-4">{block.text}</h2>;
        case 'paragraph':
          return <p key={index} data-testid={testId} className="text-gray-600 mb-4">{block.text}</p>;
        case 'conclusion':
          return <p key={index} data-testid={testId} className="mt-8 pl-5 border-l-4 border-[#E30022] text-gray-700 font-medium">{block.text}</p>;
        default:
          return null;
      }
    })}
  </div>
);